var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookBookmark = function SvgBookBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 162,
    fill: "none",
    viewBox: "0 0 132 162"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEEF7",
    d: "M154.375 17.813H53.438a23.75 23.75 0 0 0-23.75 23.75V166.25a5.935 5.935 0 0 0 5.937 5.938H142.5a5.93 5.93 0 0 0 4.198-1.74 5.934 5.934 0 0 0 0-8.396 5.93 5.93 0 0 0-4.198-1.74H41.563a11.874 11.874 0 0 1 11.874-11.874h100.938a5.93 5.93 0 0 0 4.198-1.74 5.93 5.93 0 0 0 1.739-4.198V23.75a5.935 5.935 0 0 0-5.937-5.937m-17.813 71.25-19.007-14.25a2.97 2.97 0 0 0-3.562 0L95 89.063V29.688h41.562z"
  })));
};
export default SvgBookBookmark;